import React, { createContext, useContext, useMemo } from 'react';
import { getRegionContextFromPathname } from '../Utils/region';

const RegionContext = createContext({ region: 'us', basePath: '' });

export const RegionProvider = ({ children, initialRegion, initialBasePath }) => {
  const { region, basePath } = useMemo(() => {
    if (initialRegion || initialBasePath !== undefined) {
      return {
        region: initialRegion || 'us',
        basePath: initialBasePath || '',
      };
    }
    return getRegionContextFromPathname(window.location.pathname || '');
  }, [initialRegion, initialBasePath]);

  const value = useMemo(() => ({ region, basePath }), [region, basePath]);
  return <RegionContext.Provider value={value}>{children}</RegionContext.Provider>;
};

export const useRegion = () => useContext(RegionContext);

